// ⚠️ Mirror file: apps/mobile/src/presentation/components/content/forwardPayload.ts
import EmailAttachment from "@/domain/entities/emails/EmailAttachement";

type RemovedAttachment = { name: string; contentType: string };
type NewAttachment = {
    name: string;
    contentType: string;
    contentBytes: string;
};

export type ForwardAttachmentChanges = {
    removedAttachments: RemovedAttachment[];
    newAttachments: NewAttachment[];
};

export const forwardOriginalAttachments = (
    attachments: EmailAttachment[] | undefined,
): EmailAttachment[] =>
    (attachments ?? []).filter((attachment) => !attachment.isEmbeddedInBody());

/** Appariement sur l'identité, désignation par nom et type. */
export const forwardRemovedAndAdded = (
    originals: EmailAttachment[],
    current: EmailAttachment[],
): ForwardAttachmentChanges => {
    const currentIds = new Set(current.map((attachment) => attachment.id));
    const originalIds = new Set(originals.map((attachment) => attachment.id));

    return {
        removedAttachments: originals
            .filter((attachment) => !currentIds.has(attachment.id))
            .map((attachment) => ({
                name: attachment.name,
                contentType: attachment.type,
            })),
        newAttachments: current
            .filter((attachment) => !originalIds.has(attachment.id))
            .map((attachment) => ({
                name: attachment.name,
                contentType: attachment.type,
                // Miroir mobile : les octets sont dans `preview`.
                contentBytes: attachment.path,
            })),
    };
};
